module.exports = __webpack_public_path__ + "img/appoint.11d3000a.png";